export default __webpack_public_path__ + "static/media/944.42dbce4d.png";